import { render, staticRenderFns } from "./Finish-reset.vue?vue&type=template&id=133868ba&scoped=true&"
import script from "./Finish-reset.vue?vue&type=script&lang=js&"
export * from "./Finish-reset.vue?vue&type=script&lang=js&"
import style0 from "./Finish-reset.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Finish-reset.vue?vue&type=style&index=1&id=133868ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133868ba",
  null
  
)

export default component.exports